if (!customElements.get('liora-trust-rotator')) {
  class LioraTrustRotator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.items = Array.from(this.querySelectorAll('.liora-trust-rotator__item'));
      this.dots = Array.from(this.querySelectorAll('.liora-trust-rotator__dots span'));
      this.index = 0;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.intervalMs = Number(this.dataset.interval) || 3000;

      if (this.items.length < 2 || this.reduceMotion) return;

      this.start = this.start.bind(this);
      this.stop = this.stop.bind(this);
      this.addEventListener('mouseenter', this.stop);
      this.addEventListener('mouseleave', this.start);
      this.addEventListener('focusin', this.stop);
      this.addEventListener('focusout', this.start);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      this.stop();
      this.timer = window.setInterval(() => this.show(this.index + 1), this.intervalMs);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    show(nextIndex) {
      const next = nextIndex % this.items.length;
      this.items.forEach((item, index) => {
        const active = index === next;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === next));
      this.index = next;
    }
  }

  customElements.define('liora-trust-rotator', LioraTrustRotator);
}